// src/eventslive/elKeyframes.ts — injects the Events Live CSS keyframes once.
// The volunteer surfaces use inline styles (to match the prototype pixel-for-
// pixel); the few animations they reference live here and are appended to
// <head> on first use. Idempotent — guarded by element id.

const EL_KEYFRAMES = `
@keyframes el-pulse { 0% { box-shadow: 0 0 0 0 rgba(19,122,82,0.5); } 70% { box-shadow: 0 0 0 6px rgba(19,122,82,0); } 100% { box-shadow: 0 0 0 0 rgba(19,122,82,0); } }
@keyframes el-conn { 0%, 100% { box-shadow: 0 0 0 0 rgba(128,232,168,0.65); } 50% { box-shadow: 0 0 0 5px rgba(128,232,168,0); } }
@keyframes el-fade-up { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; } }
@keyframes el-fade { from { opacity: 0; } to { opacity: 1; } }
@keyframes el-live { 0%, 100% { opacity: 1; } 50% { opacity: 0.45; } }
@keyframes el-pulse-sage { 0%, 100% { box-shadow: 0 0 0 0 rgba(128,232,168,0.5); } 70% { box-shadow: 0 0 0 7px rgba(128,232,168,0); } }
@keyframes el-pulse-red { 0%, 100% { box-shadow: 0 0 0 0 rgba(239,83,80,0.5); } 70% { box-shadow: 0 0 0 6px rgba(239,83,80,0); } }
@keyframes el-sheet-up { from { transform: translateY(100%); } to { transform: translateY(0); } }
`;

export function ensureElKeyframes(): void {
  if (typeof document === "undefined") return;
  if (document.getElementById("el-keyframes")) return;
  const el = document.createElement("style");
  el.id = "el-keyframes";
  el.textContent = EL_KEYFRAMES;
  document.head.appendChild(el);
}
